import { create } from 'zustand';
import { SearchStore } from '../types/search';

const useSearchStore = create<SearchStore>((set) => ({
  selectedDataset: null,
  setSelectedDataset: (dataset) => set({ selectedDataset: dataset }),

  selectedSearchId: '',
  setSelectedSearchId: (id) => set({ selectedSearchId: id }),

  searchId: '',
  setSearchId: (id) => set({ searchId: id }),
}));

export default useSearchStore;
